import React from 'react';
import { ArrowRight } from 'lucide-react';
import { brandInfo } from '../data/mock';

const Hero = () => {
  const scrollToGallery = () => {
    const element = document.querySelector('#gallery');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section-custom">
      <div className="container mx-auto px-4 lg:px-8 h-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center h-full py-16 lg:py-0">
          {/* Left Content */}
          <div className="space-y-6 lg:space-y-8">
            <div className="space-y-4">
              <h1 className="hero-heading-custom">
                {brandInfo.tagline}
              </h1>
              <p className="body-large-custom">
                {brandInfo.about}
              </p>
              <p className="body-medium-custom opacity-60">
                Custom artwork starting below ₹799
              </p>
            </div>
            
            <div className="flex flex-wrap gap-4">
              <button onClick={scrollToGallery} className="cta-button large">
                View Gallery
                <ArrowRight size={16} className="ml-2" />
              </button>
              <button onClick={scrollToContact} className="cta-button-outline large">
                Order Custom Art
              </button>
            </div>

            <div className="flex gap-3 flex-wrap">
              <span className="service-button" style={{ background: '#88a2ff' }}>Sketches</span>
              <span className="service-button" style={{ background: '#78d692' }}>Paintings</span>
              <span className="service-button" style={{ background: '#ff84e4' }}>Portraits</span>
              <span className="service-button" style={{ background: '#ffe03d' }}>Wildlife</span>
            </div>
          </div>

          {/* Right Content - Featured Artwork */}
          <div className="grid grid-cols-2 gap-4 lg:gap-6">
            <div className="space-y-4 lg:space-y-6">
              <div className="artwork-card-hero">
                <img 
                  src="https://customer-assets.emergentagent.com/job_1a50b2a8-6e90-491e-ad84-b5769dd7737d/artifacts/jnyx6903_IMG_0294.jpeg"
                  alt="Sailboat sketch"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="artwork-card-hero">
                <img 
                  src="https://customer-assets.emergentagent.com/job_1a50b2a8-6e90-491e-ad84-b5769dd7737d/artifacts/hcman0lk_IMG_0297.jpeg"
                  alt="Bird painting"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="space-y-4 lg:space-y-6 pt-8">
              <div className="artwork-card-hero">
                <img 
                  src="https://customer-assets.emergentagent.com/job_1a50b2a8-6e90-491e-ad84-b5769dd7737d/artifacts/xm0x7zw8_IMG_0296.jpeg"
                  alt="Eyes artwork"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="artwork-card-hero">
                <img 
                  src="https://customer-assets.emergentagent.com/job_1a50b2a8-6e90-491e-ad84-b5769dd7737d/artifacts/m2pbvyy4_IMG_0298.jpeg"
                  alt="Shiva painting"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
